import { Component, OnInit, ViewEncapsulation, NgZone, OnDestroy } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import * as myGlobals from '../../shared/globalcontants'; // CONSTANT FILE ADD ANY CONSTANT VALUE
import { Router, NavigationEnd, RouterLinkActive } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CSharpRequestService } from 'src/app/shared/services/csharp-request.service';
import _ from 'lodash';
import { APIServiceProviderService } from 'src/app/shared/services/APIServices/APIServiceProviderService/APIServiceProviderService';
import { PrevilegeAuthorizationService } from 'src/app/authorization/services/privilege-authorization.service';
import { UserDetailLandingEntity } from 'src/app/shared/models/Licence/UserDetailLandingEntity';
import { UserLicenceDetailsEntity } from 'src/app/shared/models/Licence/UserLicenceDetailsEntity';
import { PopupComponent } from 'src/app/shared/popup/popup.component';
import { MatDialog } from '@angular/material/dialog';
import { UIMenuEntity } from 'src/app/shared/models/Application/UIMenuEntity';
import {IntercoUnAvailableModules} from 'src/app/shared/globalcontants'; // CONSTANT FILE ADD ANY CONSTANT VALUE
import { CheckIsAd } from 'src/app/auth-config.interface';
import { MsalService } from '@azure/msal-angular';
import { ConfigService } from 'src/app/config.service';
import * as appApiResources from '../../shared/globalcontants';
import { cSharpActionName } from '../../shared/globalcontants';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { NgClass } from '@angular/common';
import { EatecTokenRefreshService } from 'src/app/core/services/eatec-token-refresh.service';
import { clearEatecTokenAuxStorage } from 'src/app/core/services/eatec-token-session.helper';
import { FullStoryService } from 'src/app/shared/services/fullstory.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, RouterLinkActive]
})
export class NavbarComponent implements OnInit, OnDestroy {
  public isCollapsed = true;
  public inReceivingLanding = false;
  public MenuList;
  public collapsemenu = false;
  public menus: any;
  public selectedMenu: any;
  public hoveredMenu: any;
  public copyMenuList: any;
  activeMenu: any;
  activeMenuSubscription: Subscription;
  public loggedInUserId = 0;
  public loggedInUserName = '';
  public loggedInSiteId = 0;
  IsAdUser:boolean;
  adDataInfo: any;
  IsAdUSerLoggedIn = sessionStorage.getItem('IsAdUser') =='true' ? true :false;
  // isMasterSyncComplete = localStorage.getItem('masterDataSynced') === 'true' ? true : false;
  constructor(
    public _cs: CommonService,
    private router: Router,
    private translateService: TranslateService,
    private authentication: AuthenticationService,
      private apiServiceProviderService: APIServiceProviderService,
      private csharpService: CSharpRequestService, private _ngZone: NgZone, private dialog: MatDialog,
      private previlegeAuthorizationService: PrevilegeAuthorizationService,  private authService: MsalService, private azureConfig: ConfigService,
      private fullStoryService: FullStoryService) {
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;   // trick the Router into believing it's last link wasn't previously loaded
        window.scrollTo(0, 0);  // if you need to scroll back to top, here is the right place

        if (!this._cs.apiUrl) {
          if (localStorage.hasOwnProperty('apiUrl')) {
            const apiUrl = window.localStorage.getItem('apiUrl');
            this._cs.apiUrl = apiUrl;
          }
        } else {
          window.localStorage.setItem('apiUrl', this._cs.apiUrl);
        }

        window.localStorage.setItem('searchChar', this._cs.searchChar);
        window.localStorage.setItem('quantityFocus', ((this._cs.quantityFocus === null ) ? 'true' : this._cs.quantityFocus ));
        window.localStorage.setItem('LocalBarcodeScan', ((this._cs.LocalBarcodeScan === null ) ? 'false' : this._cs.LocalBarcodeScan));
        window.localStorage.setItem('barcodeAutoIncrement', this._cs.barcodeAutoIncrement);
        window.localStorage.setItem('newBarcode', this._cs.barCode.toString());
        window.localStorage.setItem('session', this._cs.session);
        window.localStorage.setItem('autoSync', this._cs.autoSync);
        window.localStorage.setItem("sessionToggle",this._cs.sessiontoggle)
        // window.localStorage.setItem("version", this._cs.version);
        if (this._cs.fromNav) {
          this._cs.currenttabIndex = 0;
        }
        this.adDataInfo = this.azureConfig.getSettings('AdData')
        this.IsAdUser = ( this.adDataInfo && this.adDataInfo.IsAdEnabled ) ? true : false;
        const checkToast = document.querySelector('#app-toast .eatec-toast-message');
        if (checkToast != null) {
          (<HTMLElement>checkToast).style.display = 'none';
        }
      }
    });

    this.isCollapsed = _cs.toogleOpen;
    this.MenuList = myGlobals.MENUARRAY;
    this.getMenu();
    this._cs.onlineStatusChange.subscribe((value) => {
      this.offlineNotSupportedPageReceiving(value);
        let index = this.menus.findIndex((e => e.Caption === "In-transit Delivery"));
        const IntransitPermission = this.GetIntransitPermission();
        this.menus[index].Enabled = this._cs.isonlineStatus && IntransitPermission ? true: false;
        this.menus[index].Visible = this._cs.isonlineStatus && IntransitPermission ? true: false;
        const enabledMenus = this.menus.filter(x => x.Enabled === true);
        const menuURL = this.menus[index].RoutingURL.split('/')[1];
        const currentURL = this.router.url.split('/')[1];
        if (menuURL === currentURL){
          this._cs.activeMenuChange.next('0');
          this.router.navigate([enabledMenus[0].RoutingURL]);
        }
      if (this._cs.isonlineStatus) {
        let index = this.menus.findIndex((e => e.Caption === "Manage Licenses"));
        let mobileLicensePermission = true;
        const authModule = this.previlegeAuthorizationService?.previlgeConfig?.previlege?.find(x => x.Name === 'mobilelicensemanagement');
        const subModule = authModule?.SubModules?.find(x => x.Name === 'mobilelicense');
        const permissions = subModule?.PermissionResource?.filter(x => x.Name === "ManageMobileLicense");
        mobileLicensePermission = permissions?.every(x => x.IsActive);
        this.menus[index].Enabled = localStorage.getItem("selectedSite") === "1" && mobileLicensePermission ? true : false;
        this.menus[index].Visible = localStorage.getItem("selectedSite") === "1" && mobileLicensePermission ? true : false;
      }
      this.hideOrShowTransferAckMenu();
      this.copyMenuList = _.cloneDeep(this.menus);
    });

  }

  GetIntransitPermission() {
    let IntransitPermission = true;
    const authModule = this.previlegeAuthorizationService?.previlgeConfig?.previlege?.find(x => x.Name === 'transactionsmanagement');
    const subModule = authModule?.SubModules?.find(x => x.Name === 'transfersin&out');
    const permissions = subModule?.PermissionResource?.filter(x => x.Name === appApiResources.PREVILEGEKEY.InTransitDelivery);
    IntransitPermission = permissions?.every(x => x.IsActive);
    return IntransitPermission;
  }

  GetTransferAckPermission() {
    try {
      let TransferAckPermission = true;
      const authModule = this.previlegeAuthorizationService?.previlgeConfig?.previlege?.find(x => x.Name === 'transactionsmanagement');
      const subModule = authModule?.SubModules?.find(x => x.Name === 'transfersin&out');
      const permissions = subModule?.PermissionResource?.filter(x => x.Name === appApiResources.PREVILEGEKEY.TransferAck);
      TransferAckPermission = permissions?.every(x => x.IsActive);
      return TransferAckPermission;
    } catch (error) {
      console.error(error);
    }
  }

  offlineNotSupportedPageReceiving(value) {
    const ShowOfflineNotSupportedPage = this.csharpService.AppVersion != null ? true : false;
    const showIsOfflineNotSupportedPage = !ShowOfflineNotSupportedPage && !value ? true : false;
    if (this._cs.selectedData && this._cs.selectedData.routerLink === this._cs.ReceivingRouteUrl) {
     if (showIsOfflineNotSupportedPage) {
      this._cs.titleOptions = {
        'back': false,
        'pageTitle': this.translateService.instant('offline.SavedReceiving'),
        'action': false
      };
      this._cs.component = this;
      this.inReceivingLanding = false;
      this.router.navigate(['/OfflineNotSupported']);
     } else {
       if (!this.inReceivingLanding) {
          this.inReceivingLanding = true;
          this._cs.titleOptions = {
            'back': false,
            'pageTitle': '',
            'showTitle': false,
            'action': false
          };
          this._cs.component = this;
          const receivingMenu = this._cs.getMenuItemList().filter((item) => item.routerLink === this._cs.ReceivingRouteUrl);
          this.router.navigate([receivingMenu[0].routerLink]);
       }
     }
    }
  }

  offlineReceivingMenuChange(value) {
    const ShowOfflineNotSupportedPage = this.csharpService.AppVersion != null ? true : false;
    const showIsOfflineNotSupportedPage = !ShowOfflineNotSupportedPage && !value ? true : false;
    if (this._cs.selectedData && this._cs.selectedData.routerLink === this._cs.ReceivingRouteUrl) {
     if (showIsOfflineNotSupportedPage) {
      this._cs.titleOptions = {
        'back': false,
        'pageTitle': this.translateService.instant('offline.SavedReceiving'),
        'action': false
      };
      this._cs.component = this;
      this.inReceivingLanding = false;
       this.router.navigate(['/OfflineNotSupported']);
     } else {
      this.inReceivingLanding = true;
      this._cs.titleOptions = {
        'back': false,
        'pageTitle': '',
        'showTitle': false,
        'action': false
      };
      this._cs.component = this;
      const receivingMenu = this._cs.getMenuItemList().filter((item) => item.routerLink === this._cs.ReceivingRouteUrl);
      this.router.navigate([receivingMenu[0].routerLink]);
     }
    }
  }
  /**
   * @function opensubmenu;
   * @param boolean Value
   * @description If click the opensubmenu Function Collapmenu Expand the Sub menu
   */
  opensubmenu() {
    if (this._cs.slideOpen) {
      this.collapsemenu = !this.collapsemenu;
    }
  }

  /**
* @function opensubmenu;
* @param boolean Value
* @description If click the opensubmenu Function Collapmenu Expand the Sub menu
*/
  openPage(data) {
    this.selectedMenu = data;
  }

  /**
 * @function opensubmenu;
 * @param boolean Value
 * @description If click the opensubmenu Function Collapmenu Expand the Sub menu
 */
  async selectedMenuItem(data: any, ItemMenu: any ) {
    this.navChangeFunctionality(data, ItemMenu);
  }

  async navChangeFunctionality(data: any, ItemMenu: UIMenuEntity) {
    this.activeMenu=data;
    this.hoveredMenu = data;
    this._cs.slideOpen = false;
    this._cs.expandMenu = false;
    this._cs.fromNav = true;
    this._cs.activeMenuChange.next(data);
    // if ( ItemMenu.hasOwnProperty('RoutingURL') && ItemMenu.RoutingURL === this._cs.ReceivingRouteUrl) {
    //   await this.SetReceivingLocation();
    // }
    this._cs.ReceivingMenu = ItemMenu.RoutingURL;
    this._cs.selectedData = ItemMenu;
    this._cs.selectedMenu = ItemMenu.Name.toLowerCase();
    if ( ItemMenu.hasOwnProperty('RoutingURL') && ItemMenu.RoutingURL === '/login') {
      this.logout();
    } else {
      this.authorizationValidateMenu(ItemMenu);
    }
  }
  /**
   * @version 13.2
   * @method authorizationValidateMenu
   * @param ItemMenu 
   */
   authorizationValidateMenu(ItemMenu: UIMenuEntity): void{
     try {
      // if ( ItemMenu.hasOwnProperty('RoutingURL') && ItemMenu.RoutingURL === this._cs.ReceivingRouteUrl) {
      //   this.offlineReceivingMenuChange(this._cs.isonlineStatus);
      // } else {
      //   this.router.navigate([ItemMenu.RoutingURL]);
      // }
      this.router.navigate([ItemMenu.RoutingURL]);
     } catch ( error ) {
       console.error(error);
     }
   }



  authorizatiomenuValidate(ItemMenu: any) {
    const moduleName = this.previlegeAuthorizationService.getPrevilageLandingkey(ItemMenu.name);
    const isAccesed = this.previlegeAuthorizationService.findLandingAuthorization(moduleName);
    if ((moduleName[0] === 'No Previlege Needed')) {
      this.router.navigate([ItemMenu.routerLink]);
    } else {
      if (isAccesed) {
        // if (ItemMenu.routerLink === this._cs.ReceivingRouteUrl) {
        //   this.offlineReceivingMenuChange(this._cs.isonlineStatus);
        // } else {
        //   this.router.navigate([ItemMenu.routerLink]);
        // }
        this.router.navigate([ItemMenu.routerLink]);
      } else {
        this.router.navigate(['/auth-denied']);
        // this.router.navigate([ItemMenu.routerLink]);
      }
    }

  }
  async SetReceivingLocation() {
    if (localStorage.hasOwnProperty('transactionId')) {
      localStorage.removeItem('transactionId');
    }
    if (localStorage.hasOwnProperty('IsOfflinePage')) {
      localStorage.removeItem('IsOfflinePage');
    }

  }



  /**
  * @function opensubmenu;
  * @param boolean Value
  * @description If click the opensubmenu Function Collapmenu Expand the Sub menu
  */
  undoSelection(i) {
    this.selectedMenu = -1;    
  }
  /**
* @function getmenulist;
* @param null
* @description To get the list of menus available
*/
  async getMenu() {
    this.menus = this._cs.getMenuItemList().filter((item) => item.Name !== 'Messages');    
    if(localStorage.getItem("selectedSite")==="1"){
      this.menus = this.menus.filter(function(e) {
        return IntercoUnAvailableModules.indexOf(e.Caption) < 0;
      });
    }    
    const IsAduser = sessionStorage.getItem('IsAdUser') == 'true' ? true : false;
    if(!IsAduser){
      this.menus.splice(this.menus.findIndex(e=> e.Caption === "Pin Configuration"),1);
    }
    if(!this._cs.isonlineStatus){
      this.menus.splice(this.menus.findIndex(e=> e.Caption === "Document Approvals"),1);
    }
    if (this._cs.IsRguest) {      
      this.menus = this.menus.filter(x => x.routerLink !== '/offline');
      this.menus.splice(this.menus.findIndex(e=> e.Caption === "About"),1)
      if(!this._cs.isonlineStatus){
        this.menus.splice(this.menus.findIndex(e=> e.Caption === "Transfers"),1)
      }
    }
    if (this._cs.isonlineStatus) {
      let index = this.menus.findIndex((e => e.Caption === "Manage Licenses"));
      let mobileLicensePermission = true;
      const authModule = this.previlegeAuthorizationService?.previlgeConfig?.previlege?.find(x => x.Name === 'mobilelicensemanagement');
      const subModule = authModule?.SubModules?.find(x => x.Name === 'mobilelicense');
      const permissions = subModule?.PermissionResource?.filter(x => x.Name === "ManageMobileLicense");
      mobileLicensePermission = permissions?.every(x => x.IsActive);
      this.menus[index].Enabled = localStorage.getItem("selectedSite") === "1" && mobileLicensePermission;
      this.menus[index].Visible = localStorage.getItem("selectedSite") === "1" && mobileLicensePermission;
    }
    this.hideOrShowTransferAckMenu();
    if(!this._cs.isonlineStatus){
      let index= this.menus.findIndex((e=> e.Caption === "In-transit Delivery"));
      this.menus[index].Enabled=false;
      this.menus[index].Visible=false;
    }
    this.copyMenuList = _.cloneDeep(this.menus);
    this.menus.forEach((x: UIMenuEntity) => {
      const name = 'uiMenus.' + x.Name;
      x.Name = this.translateService.instant(name);
    });
  }

  hideOrShowTransferAckMenu() {
    const index = this.menus.findIndex(x => x.Caption === "Transfer Acknowledgement");
    if (index !== -1) {
      if (this._cs.isonlineStatus) {
        const showAckPopup = localStorage.getItem('ShowTransferAcknowledgement') === 'True';
        const transferAckPermission = this.GetTransferAckPermission();
        this.menus[index].Visible = showAckPopup && transferAckPermission;
        this.menus[index].Enabled = showAckPopup && transferAckPermission;
      } else {
        this.menus[index].Visible = false;
        this.menus[index].Enabled = false;
      }
    }
  }

  /**
  * @function closemenu;
  * @param boolean Value
  * @description If click the closemenu function close the side menu automatically
  */

  closemenu() {
    this._cs.expandMenu = !this._cs.expandMenu;
  }

  /**
  * @function logout;
  * @param None
  * @description If click the logout function logout the application and clear the session storage and webstorage
  * Note: If click the logout function Clear the all local storage
  */

  async logout() {
    EatecTokenRefreshService.stopRefreshTimer();
    clearEatecTokenAuxStorage();
    // var clientId = localStorage.getItem(myGlobals.LoggedInClientId.toString());
    const refreshToken = JSON.parse(localStorage.getItem(myGlobals.userSessionName.toString()));
    this._cs.InactivityTimeout.next(0);
    const deviceId = localStorage.getItem(myGlobals.DeviceId.toString());
    const userData = JSON.parse(sessionStorage.getItem(myGlobals.userInfo.toString()));
    if (refreshToken && deviceId && refreshToken !== '' && deviceId !== '' && userData.GroupId !== 5) {
      const licenceLogoutUser = new UserLicenceDetailsEntity();
      licenceLogoutUser.DeviceId = deviceId;
      licenceLogoutUser.usertoken = refreshToken ? refreshToken.access_token : '';
      // licenceLogoutUser.ClientRefreshToken = clientId ? clientId : '';
      const postObject = [];
      postObject.push(licenceLogoutUser);
      //this.apiServiceProviderService.licencingService.SuspendUserPost(postObject).toPromise();
    } 
    this._cs.passcodePopupShow.next(false);
    this._cs.tempPasscodePopupShow.next(false);
    this.authentication.updateMobileLicenseLogout();
    if(this.IsAdUser && this._cs.isonlineStatus &&
      !this._cs.directLogin && this.authService?.instance?.getActiveAccount()) {
      await this.authService?.instance?.logoutRedirect();
    }
    localStorage.removeItem(myGlobals.LoggedInClientId.toString());
    localStorage.removeItem(myGlobals.userSessionName.toString());
    localStorage.removeItem('uiMenus');
    localStorage.removeItem('instanceName');
    localStorage.removeItem('AuthorizationData');
    localStorage.removeItem('GlobalSettings');
    localStorage.removeItem('IsAgilysysEmployee');
    sessionStorage.clear();
    this.fullStoryService.shutdown();
    this.router.navigate(['/login']);
  }

  ngOnInit() {
    const _that = this;
    const menu = JSON.parse(localStorage.getItem("currentUserNavigationMenus"));      
    this.activeMenuSubscription = this._cs.activeMenuChange.subscribe((value) => {
      _that.activeMenu = value;
      _that.hoveredMenu = value;
      if(_that.menus[value]?.Caption == "Offline"){
        _that._cs.isOffline = true;
      }
      else{
        _that._cs.isOffline = false;
      }
    });
    for(var index in this.menus){
      if(_that.menus[index].Name===menu[0].Name){
        _that.activeMenu = index;
        _that.hoveredMenu = index;        
      }
    }
    _that._cs.MenuChangeToReq.subscribe((value) => {
      if (value === true && _that.menus) {
        const reqUiMenu = _that.menus.filter(x => x.Icon === 'requisition')[0];
        if (reqUiMenu) {
          const index = this.menus.indexOf(reqUiMenu);
          _that.selectedMenuItem(index, reqUiMenu);
        }
      }
    });
    if(_that._cs.isPasscodeExpired && (!_that._cs.directLogin || (_that._cs.directLogin && sessionStorage.getItem('IsAdUser').toString() == 'true')) && localStorage.getItem('IsAD') === 'true' && _that._cs.isonlineStatus){
      var ind = _that.menus.indexOf(_that.menus.find(x => x.RoutingURL == '/passcode'));
      _that.activeMenu = ind;
      _that.hoveredMenu = ind;    
    }
  }

  ngOnDestroy() {
    this.activeMenuSubscription.unsubscribe();
    this._cs.MenuChangeToReq.next(false);

  }
}
